var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");
name.prefix = require("./prefix");
name.suffix = require("./suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pt_BR/name/index.js
 ** module id = 964
 ** module chunks = 0
 **/